(() => {
  if (window.__customSwishWishlistInit) return;
  window.__customSwishWishlistInit = true;

  const BUTTON_SELECTOR = "[data-custom-wishlist-button]";
  const HEADER_LINK_SELECTOR = "[data-custom-wishlist-link]";

  function toPositiveInteger(value) {
    const number = Number(String(value || "").replace(/[^0-9]/g, ""));
    return Number.isFinite(number) && number > 0 ? number : 0;
  }

  function initHeaderWishlistCountGuard() {
    let link = document.querySelector(HEADER_LINK_SELECTOR);
    let counter = null;
    let lastSeenCount = 0;
    let isRestoring = false;

    function refreshElements() {
      link = document.querySelector(HEADER_LINK_SELECTOR);
      counter = link
        ? link.querySelector(".custom-wishlist-link__count[data-custom-wishlist-count]")
        : null;

      return Boolean(link && counter);
    }

    function showCount(count) {
      if (!refreshElements() || !count) return;

      isRestoring = true;

      counter.textContent = String(count);
      counter.hidden = false;
      counter.removeAttribute("hidden");

      link.dataset.customWishlistCount = String(count);
      link.classList.add("wk-has-items");
      link.classList.remove("wk-selected");
      link.setAttribute("aria-label", `Wunschliste, ${count} Artikel`);

      window.requestAnimationFrame(() => {
        isRestoring = false;
      });
    }

    function readVisibleOrTextCount() {
      if (!refreshElements()) return 0;

      return (
        toPositiveInteger(counter.textContent) ||
        toPositiveInteger(counter.getAttribute("data-count")) ||
        toPositiveInteger(counter.getAttribute("aria-label")) ||
        toPositiveInteger(link.dataset.customWishlistCount)
      );
    }

    function reconcile() {
      if (!refreshElements() || isRestoring) return;

      /*
        Nur Schutz gegen erneutes Re-Rendering:
        Wenn Swish den Header bereits als geladen markiert hat,
        darf die Loading-Klasse nicht wieder sichtbar bleiben.
        Diese Datei setzt customWishlistLoaded aber NICHT selbst.
      */
      if (
        link &&
        link.dataset.customWishlistLoaded === "true" &&
        link.classList.contains("custom-wishlist-link--loading")
      ) {
        link.classList.remove("custom-wishlist-link--loading");
      }

      const currentCount = readVisibleOrTextCount();

      if (currentCount > 0) {
        lastSeenCount = currentCount;
        showCount(currentCount);
        return;
      }

      if (
        lastSeenCount > 0 &&
        (counter.hidden || counter.hasAttribute("hidden") || !counter.textContent.trim())
      ) {
        showCount(lastSeenCount);
      }
    }

    if (!refreshElements()) {
      const documentObserver = new MutationObserver(() => {
        if (refreshElements()) {
          documentObserver.disconnect();
          initHeaderWishlistCountGuard();
        }
      });

      documentObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });

      return;
    }

    const observer = new MutationObserver(() => {
      if (
        link &&
        link.dataset.customWishlistLoaded === "true" &&
        link.classList.contains("custom-wishlist-link--loading")
      ) {
        link.classList.remove("custom-wishlist-link--loading");
      }

      reconcile();
    });

    observer.observe(counter, {
      attributes: true,
      attributeFilter: ["hidden", "class", "style", "data-count", "aria-label"],
      childList: true,
      characterData: true,
      subtree: true,
    });

    observer.observe(link, {
      attributes: true,
      attributeFilter: [
        "class",
        "aria-label",
        "data-custom-wishlist-count",
        "data-custom-wishlist-loaded",
      ],
    });

    reconcile();

    window.setTimeout(reconcile, 150);
    window.setTimeout(reconcile, 500);
    window.setTimeout(reconcile, 900);
  }

  document.addEventListener(
    "click",
    (event) => {
      const button = event.target.closest(BUTTON_SELECTOR);

      if (!(button instanceof HTMLButtonElement)) return;

      if (button.dataset.swishReady === "true") {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      button.dataset.customWishlistPending = "1";
      button.setAttribute("aria-busy", "true");
      button.classList.add("custom-wishlist-button--pending");
    },
    true
  );

  document.addEventListener("variant:update", (event) => {
    const variantId = event.detail?.resource?.id;
    const productId = event.detail?.data?.productId;

    if (!variantId) return;

    document
      .querySelectorAll("[data-custom-wishlist-button][data-pdp-wishlist-button]")
      .forEach((button) => {
        if (!(button instanceof HTMLButtonElement)) return;

        if (productId && button.dataset.productId !== String(productId)) {
          return;
        }

        if (button.dataset.variantId === String(variantId)) {
          return;
        }

        const clone = button.cloneNode(true);

        clone.dataset.variantId = String(variantId);
        delete clone.dataset.swishReady;
        delete clone.dataset.customWishlistPending;
        delete clone.dataset.customWishlistProcessing;

        clone.setAttribute("aria-busy", "true");
        clone.setAttribute("aria-pressed", "false");
        clone.setAttribute("aria-label", "Zur Wunschliste hinzufügen");

        clone.classList.remove(
          "wk-selected",
          "custom-wishlist-button--selected",
          "custom-wishlist-button--pending"
        );

        clone.classList.add("custom-wishlist-button--loading");

        button.replaceWith(clone);
      });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeaderWishlistCountGuard, { once: true });
  } else {
    initHeaderWishlistCountGuard();
  }
})();